<template>
  <v-card rounded="xl" min-height="800px" outlined class="overflow-hidden">
    <v-data-table
        :headers="headers_table_state"
        :items="index_technical_maps"
        :search="search_table"
        :items-per-page="12"
        :page.sync="page"
        @page-count="pageCount = $event"
        item-key="id"
        :loading="loading_list_tech_maps"
        loading-text="Загрузка заявлений... пожалуйста подождите"
        no-data-text="По предложенным критериям данные отсутствуют"
        hide-default-footer
        mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-app-bar
            elevation="0"
        >
          <v-chip
              v-if="check_role !== -1"
              class="ma-2"
              outlined
          >
            <v-avatar
                left
                class="teal white--text"
            >
              {{ count_all_tech_maps }}
            </v-avatar>
            Общее количество технологических карты
          </v-chip>

          <v-spacer></v-spacer>

          <v-text-field
              v-model="search_table"
              label="Поиск"
              dense
              outlined
              rounded
              hide-details
              clearable
              @click:clear="search_table = ''"
          >
            <template v-slot:prepend-inner>
              <div style="height: 100%" class="align-center justify-center">
                <v-icon size="20px">
                  fa-search
                </v-icon>
              </div>
            </template>
          </v-text-field>
        </v-app-bar>
      </template>
      <template v-slot:item.list_educational_programms="{ item }">
        <div class="pa-2">
          <v-chip-group
              v-if="item.type_course === 'Стандарт'"
              class="d-flex justify-center"
              column
          >
            <v-chip
                class="d-flex"
                outlined
                v-for="ep in item.list_educational_programms"
                :key="ep.id"
            >
              {{ ep.speciality_name }}
            </v-chip>
          </v-chip-group>
          <v-chip-group
              v-else
              class="d-flex justify-center"
              column
          >
            <v-chip
                class="d-flex"
                outlined
            >
              Для всех направлений подготовки
            </v-chip>
          </v-chip-group>
        </div>
      </template>
      <template v-slot:item.status_commission="{ item }">
        <v-chip-group v-if="item.commission.length > 0">
          <v-chip
              v-for="comm in item.commission"
              :key=comm.id
              small
              rounded
              elevation="0"
              :color="setStatus(comm).color"
              outlined
          >
            {{ setStatus(comm).name }}
          </v-chip>
        </v-chip-group>
        <v-chip
            v-else
            small
            rounded
            elevation="0"
            color="grey"
            outlined
        >
          Не оценено
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
            @click="openSelectedTechMap(item)"
            icon
        >
          <v-icon size="15px">
            fa fa-chevron-right
          </v-icon>
        </v-btn>
        <v-navigation-drawer
            class="rounded-xl"
            width="100%"
            v-model="drawer"
            right
            floating
            hide-overlay
            absolute
        >
          <v-card
              v-if="loading_current_tech_map"
              min-width="100%"
              height="100%"
              elevation="0"
              tile
          >
            <v-layout class="justify-center align-center fill-height">
              <v-progress-circular :size="240" :width="6" indeterminate color="teal"></v-progress-circular>
            </v-layout>
          </v-card>

          <v-card v-else elevation="0">
            <v-card-title style="width: 100%">
              <v-btn icon @click="drawer = !drawer">
                <v-icon size="15px">
                  fa-chevron-left
                </v-icon>
              </v-btn>
              <div class="text-h6">
                {{ technical_map.full_name }}
              </div>

              <v-spacer/>

              <div v-if="check_comm_ep && check_role !== -1" class="mr-2">
                <v-btn
                    @click="createFileEP"
                    elevation="0"
                    rounded
                    outlined
                    color="teal"
                >
                  <v-icon left size="15px">
                    fa-download
                  </v-icon>
                  Скачать Экс. закл. ОП
                </v-btn>
              </div>

              <div v-if="check_comm_department && check_role !== -1" class="mr-2">
                <v-btn
                    @click="createFileChair"
                    elevation="0"
                    rounded
                    outlined
                    color="teal"
                >
                  <v-icon left size="15px">
                    fa-download
                  </v-icon>
                  Скачать Экс. закл. кафедры
                </v-btn>
              </div>

              <div class="mr-2">
                <v-btn
                    @click="createFileTM"
                    elevation="0"
                    rounded
                    outlined
                    color="teal"
                >
                  <v-icon left size="15px">
                    fa-download
                  </v-icon>
                  Скачать ТК
                </v-btn>
              </div>

              <div>
                <v-btn
                    @click="estimation = true"
                    elevation="0"
                    rounded
                    outlined
                    color="teal"
                >
                  <v-icon left size="15px">
                    fa-check-square
                  </v-icon>
                  Оценить
                </v-btn>
              </div>

            </v-card-title>

            <v-divider/>

            <v-card-text class="overflow-auto overflow-x-hidden">
              <v-row class="full-height">
                <v-col cols="12" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Кафедры
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <v-list dense class="pa-0">
                        <v-list-item-group
                            color="teal"
                        >
                          <v-list-item
                              v-for="(item, i) in technical_map.list_chairs"
                              :key="i"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="text-subtitle-1" v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Образовательные программы
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <v-list class="pa-0" dense>
                        <v-list-item-group
                            color="teal"
                        >
                          <v-list-item
                              v-for="(item, i) in technical_map.list_educational_programms"
                              :key="i"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="text-subtitle-1" v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Учебный план
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <v-list class="pa-0" dense>
                        <v-list-item-group
                            color="teal"
                        >
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="text-subtitle-1" v-text="curriculum_name"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Дисциплина
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <v-list class="pa-0" dense>
                        <v-list-item-group
                            color="teal"
                        >
                          <v-list-item
                              v-for="(item, i) in technical_map.list_disciplines"
                              :key="i"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="text-subtitle-1" v-text="item"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Форма обучения
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <p class="text-subtitle-1 black--text">
                        {{ form_education }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
<!--                <v-col cols="6" class="d-flex">-->
<!--                  <v-card-->
<!--                      class="rounded-xl"-->
<!--                      outlined-->
<!--                      min-width="100%"-->
<!--                      tile-->
<!--                  >-->
<!--                    <v-card-title>-->
<!--                      <h6-->
<!--                          class="mx-auto text-caption text-uppercase text&#45;&#45;secondary"-->
<!--                      >-->
<!--                        Семестры-->
<!--                      </h6>-->
<!--                    </v-card-title>-->
<!--                    <v-card-text>-->
<!--                      <v-list class="pa-0" dense>-->
<!--                        <v-list-item-group-->
<!--                            color="teal"-->
<!--                        >-->
<!--                          <v-list-item-->
<!--                              v-for="(item, i) in semesters"-->
<!--                              :key="i"-->
<!--                          >-->
<!--                            <v-list-item-content>-->
<!--                              <v-list-item-title class="text-subtitle-1" v-text="item"></v-list-item-title>-->
<!--                            </v-list-item-content>-->
<!--                          </v-list-item>-->
<!--                        </v-list-item-group>-->
<!--                      </v-list>-->
<!--                    </v-card-text>-->
<!--                  </v-card>-->
<!--                </v-col>-->
              </v-row>
              <v-row v-if="list_cofounders">
                <v-col cols="12" class="d-flex">
                  <v-card
                      class="rounded-xl"
                      outlined
                      min-width="100%"
                      tile
                  >
                    <v-card-title>
                      <h6
                          class="mx-auto text-caption text-uppercase text--secondary"
                      >
                        Соучредители
                      </h6>
                    </v-card-title>
                    <v-card-text>
                      <p v-for="(cofounder, index) in list_cofounders" :key="index" class="text-subtitle-1 black--text">
                        {{ cofounder }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="my-4" justify="center">
                <v-card @click="getLinkCheckCourse" elevation="0">
                  <h6 class="text-sm-h5 text-h6">
                    <a
                        class="teal--text"
                    >
                      {{ technical_map.course_full_name }}
                    </a>
                  </h6>
                </v-card>
              </v-row>
              <v-row class="text-center">
                <div style="width: 100%" v-for="(semester, index) in data_semesters" :key="index">
<!--                  <v-row align="center" justify="center">-->
<!--                    <v-col cols="5">-->
<!--                      <v-divider/>-->
<!--                    </v-col>-->
<!--                    <v-col cols="2" class="text-center">-->
<!--                      <div class="my-4 text-subtitle-1">-->
<!--                        {{ semester.semester_name }}-->
<!--                      </div>-->
<!--                    </v-col>-->
<!--                    <v-col cols="5">-->
<!--                      <v-divider></v-divider>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
                  <v-row class="mb-2" justify="center">
                    <v-col v-for="(form_control, index_format_control) in semester.format_controls" cols="4" :key="index_format_control">
                      <v-autocomplete
                          :items="areas_training"
                          :value="form_control"
                          :readonly="true"
                          :rules="[v => !!v || 'Обязательное поле не заполнено']"
                          no-data-text="Данные отсутствуют"
                          label="Форма контроля"
                          dense
                          hide-details
                          rounded
                          outlined
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-chip
                      class="ma-1 pr-0"
                      outlined
                      v-for="hour in semester.hours"
                      :key="hour.id"
                  >
                    {{ hour.load }}
                    <div
                        class="rounded-pill teal pa-4 ml-2"
                    >
                      <span class="text-subtitle-1 white--text">{{ hour.value }} </span>
                      <span class="white--text"> акад. час.</span>
                    </div>

                  </v-chip>
                  <div class="mt-3">
                    <v-card class="rounded-xl overflow-hidden" outlined elevation="0" width="100%">
                      <CardTableTechMapForCommission
                          :data_tech_map="data_table[index].data_tech_map"
                          :alternative_view="alternative_view"
                      />
                    </v-card>
                  </div>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-navigation-drawer>
      </template>
    </v-data-table>
    <DialogEstimationTechMap
        :estimation="estimation"
        :selected_tech_map="technical_map"
        @closeEstimationDialog="closeEstimationDialog"
    />
    <v-card-actions v-if="index_technical_maps.length > 12">
      <v-pagination
          class="mx-auto"
          v-model="page"
          :length="pageCount"
          total-visible="8"
          color="teal"
          circle
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";
import DialogEstimationTechMap from "../EditDialogs/DialogEstimationTechMap";
import CardTableTechMapForCommission from "./CardTableTechMapForCommission.vue";
import StudyEstEukTechMapCommissionApi from "../Services/Api/StudyEstEukTechMapCommissionApi";
import StudyEstEukTechMapCommissionApiService from "../Services/Api/StudyEstEukTechMapCommissionApi";
import TechnologicalMapPDF from "../../../../makepdfs/study/technological_map_pdf";
import ExpertOpinionHeadDepartmentPDF from "../../../../makepdfs/study/expert_opinion_head_department_pdf";
import ExpertOpinionHeadEPPDF from "../../../../makepdfs/study/expert_opinion_head_ep_pdf";
import _ from "lodash";

export default {
  name: "CardListTechMaps",
  components: {
    CardTableTechMapForCommission,
    DialogEstimationTechMap
  },
  data: () => ({
    search_table: '',
    headers_table_state: [
      {text: 'СОСТАВИТЕЛЬ', value: 'full_name', sortable: false},
      {text: 'НАЗВАНИЕ КУРСА', value: 'course_full_name', sortable: false, filterable: false},
      {text: 'ОБРАЗОВАТЕЛЬНЫЕ ПРОГРАММЫ', value: 'list_educational_programms', sortable: false, filterable: false, align: "center"},
      {text: 'СТАТУС', value: 'status_commission', align: "center", sortable: false, filterable: false},
      {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', align: "center", sortable: false, filterable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: "center", filterable: false},
    ],
    page: 1,
    pageCount: 0,
    drawer: false,
    estimation: false,
    loading_current_tech_map: false,
    areas_training: ['Зачет', 'Экзамен', 'Зачет с оценкой', 'Курсовая работа', 'Защита ВКР'],
  }),
  mounted() {
    this.indexTechnicalMaps();
  },
  computed: {
    ...mapState({
      index_technical_maps: state => state.studyEstEukTechMap.index_technical_maps,
      loading_list_tech_maps: state => state.studyEstEukTechMap.loading_list_tech_maps,
      technical_map: state => state.studyEstEukTechMap.technical_map,
      count_all_tech_maps: state => state.studyEstEukTechMapAdditData.count_all_tech_maps,
    }),
    semesters() {
      return this.technical_map?.data_training?.semesters
    },
    data_semesters() {
      return this.technical_map?.data_training?.data_semesters
    },
    data_table() {
      return this.technical_map?.technological_map_data?.data_table
    },
    alternative_view() {
      return this.technical_map?.technological_map_data?.alternative_view
    },
    curriculum_name() {
      return this.technical_map?.curriculum?.name
    },
    form_education(){
      return this.technical_map?.form_education
    },
    list_cofounders(){
      return this.technical_map?.cofounders?.length > 0 ? this.technical_map?.cofounders : null
    },
    check_role(){
      return _.findIndex(this.index_technical_maps[0]?.person_commission_info?.roles,(role) => {return role.key === 3})
    },
    check_comm_department(){
      if (Object.keys(this.technical_map).length > 0){
        let comm_dep = _.find(this.technical_map.commission_members, (comm) => {
          return comm.management_type === "Department"
        })

        return (comm_dep.full_name !== "Неопределен" && comm_dep.status_review === 2)
      }
    },
    check_comm_ep(){
      if (Object.keys(this.technical_map).length > 0){
        let comm_eps = []
        let count_confirm_eps = 0

        this.technical_map.commission_members.forEach((comm) => {
          if (comm.management_type === "EducationalProgramm"){
            comm_eps.push(comm)

            if (comm.status_review === 2){
              count_confirm_eps += 1
            }
          }
        })

        return comm_eps.length === count_confirm_eps
      }
    }
  },
  methods: {
    ...mapActions({
      indexTechnicalMaps: 'studyEstEukTechMap/indexTechnicalMaps',
      getCommissionStatuses: 'studyEstEukTechMapCommission/getCommissionStatuses',
      getDetailsTechnicalMaps: 'studyEstEukTechMap/getDetailsTechnicalMaps'
    }),
    async openSelectedTechMap(item) {
      this.drawer = !this.drawer

      this.loading_current_tech_map = true

      await this.getDetailsTechnicalMaps(item.id)

      let params = {
        technological_map_id: item.id,
        role_key: item?.person_commission_info?.roles[0]?.key
      }

      await this.getCommissionStatuses(params)

      this.loading_current_tech_map = false
    },
    statusCommission(list_commission) {
      list_commission.forEach((comm)=>{

      })
      if (item_table.commission?.person_id === item_table.person_commission_info.id) {
        return item_table.commission?.status_review
      }

      return 1
    },
    setStatus(commission) {
      let name_comm = ''

      if (commission.euk_role_person === 1) {
        name_comm = 'Зав. кафедрой'
      }
      else if (commission.euk_role_person === 2) {
        name_comm = 'Рук. ОП'
      }
      else name_comm = 'Специалист ЦЭОиДПО'

      if (commission.status_review === 1) {
        return {color: 'orange', name: name_comm}
      }
      else if (commission.status_review === 2) {
        return {color: 'green', name: name_comm}
      }
      else if (commission.status_review === 3) {
        return {color: 'red', name: name_comm}
      }
    },
    closeEstimationDialog() {
      this.estimation = false
    },
    getLinkCheckCourse(){
      const StudyEstEukTechMapCommissionApi = StudyEstEukTechMapCommissionApiService

      StudyEstEukTechMapCommissionApi.get_link(this.technical_map.course_id).then((response) => {
        if (response.status === 200 || response.status === 204) {
          window.open(response.data.url, '_blank')
        }
      })
    },
    createFileTM(){
      TechnologicalMapPDF.createPDF(this.technical_map)
    },
    createFileChair(){
      ExpertOpinionHeadDepartmentPDF.createPDF(this.technical_map)
    },
    createFileEP(){
      ExpertOpinionHeadEPPDF.createPDF(this.technical_map)
    }
  }
}
</script>

<style scoped>
>>> .v-slide-group__content {
  justify-content: center;
}

</style>